import { getLabel } from "../../../../hooks/use-labels";
import HexButton from "../../../../ui-kit/HexButtons";
import ModalTitle from "../../../HexModal/ModalTitle";
import PaymentFailed from "../../assets/payment-failed.gif";

const FailedPayment = ({ onClick, buttonLabel, title, message }) => {
  return (
    <div className="text-center">
      <ModalTitle
        text={title || getLabel("paymentFailedLabel")}
        className={"mb-20"}
      />

      <div className="failed-status-image-container">
        <img
          src={PaymentFailed}
          alt="payment-failed"
          className="payment-status-image"
        />
      </div>

      <div className="payment-message">
        {message || getLabel("paymentUnsuccessfulMessage")}
      </div>
      <HexButton
        label={buttonLabel || getLabel("tryAgainLabel")}
        onClick={onClick}
        type="primary"
        size="md"
        htmlType="submit"
        className="full-width try-again-button"
      />
    </div>
  );
};

export default FailedPayment;
